// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"08c139e5","441":"9fc24d60","500":"9b8fdc00","534":"a25b0308","633":"f491f7a6","966":"bfce7163"}[chunkId] + ".chunk.css";
};